import { useQuery } from 'react-query'
import { QUERY_KEYS } from 'src/constants'
import { accountStylesService } from 'src/services/account-styles.service'

export const useAccountStyles = (accountId: string) => {
  return useQuery(
    [QUERY_KEYS.ACCOUNT_STYLES, accountId],
    () => accountStylesService.getAccountStyles(accountId),
    { refetchOnWindowFocus: false, refetchOnReconnect: false },
  )
}
